module.exports = __webpack_public_path__ + "h5/img/gift-detail-button-tip.e19cbf93.png";